<template>
  <div class="header-container">
    <div class="header-center main-width">
      <div class="header-menu">
        <i class="el-icon-refresh-right" @click="refreshPage"></i>
        <header-menu ref="HeaderMenuRef" @clickMenu=" clickMenu"></header-menu>
      </div>
      <div class="header-up" ref="HeaderUpRef">
        <div class="header-logo">
          <router-link class="top-logo-left" to="/">
            <img class="t_logo_1" src="@/assets/images/t_logo_1.png" alt="logo">
            <!-- <img class="t_logo_1" src="@/assets/images/top_logo_saggas.png" alt="logo"> -->
          </router-link>
          <router-link class="top-logo" to="/">
            <img class="t_logo_2" src="@/assets/images/t_logo_2.png" alt="logo">
          </router-link>
        </div>
        <div class="header-right" ref="HeaderRightRef">
          <header-link></header-link>
        </div>
      </div>
      <div class="header-nav" ref="HeaderNavRef">
        <div class="header-nav-container">
          <div class="nav-sidebar-h">
            <Sidebar />
          </div>
          <div class="nav-sidebar-v">
            <Sidebar mode="vertical" />
          </div>
          <header-link class="nav-link"></header-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderMenu from './headerMenu.vue';
import Sidebar from "./sideBar/index";
import HeaderLink from "./components/headerLink";
export default {
  data() {
    return {
      searchInfo: "",
      isSearch: false, // 是否为搜索状态
    }
  },
  props: {

  },
  components: {
    Sidebar,
    HeaderMenu,
    HeaderLink
  },
  mounted() {
    window.addEventListener('scroll', this.scrollListen);
  },
  methods: {
    // 检索动态样式
    searchMove() {
      this.isSearch = true;
    },
    closeSearch() {
      this.isSearch = false;
      this.searchInfo = "";
    },

    clickMenu(active) {
      this.$refs.HeaderNavRef.style.right = active ? '0' : '-100%';
      this.$refs.HeaderRightRef.style.right = active ? '0' : '-100%';
    },
    scrollListen() {
      const windowWidth = window.innerWidth;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (windowWidth < 1200) {
        this.$refs.HeaderUpRef.style.backgroundColor = scrollTop > 0 ? "#227ccf" : "transparent";
      } else {
        this.$refs.HeaderUpRef.style.backgroundColor = "transparent";
      }
    },
    refreshPage() {
      window.location.reload();
    }
  },
  watch: {
    "$route": {
      handler() {
        this.$nextTick(() => {
          this.$refs.HeaderNavRef.style.right = '-100%';
          this.$refs.HeaderRightRef.style.right = '-100%';
        })
      },
      immediate: true,
      deep: true
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollListen);
  }
}
</script>

<style lang="less" scoped>
.header-container {
  width: 100%;
  height: auto;
  background: linear-gradient(
    180deg,
    rgba(0, 98, 172, 0.5) 0%,
    rgba(0, 98, 172, 0) 100%
  );
  .nav-sidebar-h {
    display: block;
  }
  .nav-sidebar-v {
    display: none;
  }
  .nav-link {
    display: none;
  }
  .el-divider--vertical {
    margin: 0 8px !important;
  }
  .header-center {
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    font-size: 20px !important;
    .header-nav {
      width: 100%;
    }
    .header-up {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .top-logo-left {
        width: 232px;
        height: 110px;
        margin-right: 60px;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: center;
        img {
          display: block;
          object-fit: contain;
          width: 100%;
          height: auto;
          margin: 4px 0;
        }
      }
      .top-logo {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        width: auto;
        height: 54px;
        img {
          display: block;
          width: auto;
          height: 100%;
          margin: 4px 0;
        }
      }
    }
    .header-logo {
      display: flex;
      align-items: center;
    }
  }
  .header-menu {
    display: none;
  }

  // ul背景色
  .el-menu.el-menu--horizontal {
    background-color: transparent;
    border-bottom: none;
  }
  // li背景色
  /deep/ .el-menu--horizontal > .el-submenu {
    background-color: transparent;
  }
  // li内div
  /deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
    color: #fff;
    background-color: transparent;
    border-bottom: none;
    padding: 0;
    font-size: 18px;
  }
  /deep/ .el-submenu__title i {
    color: #fff;
    margin-top: 0px;
    font-size: 16px;
  }
}

@media screen and (max-width: 1200px) {
  .header-container {
    height: 130px;
    .nav-sidebar-h {
      display: none;
    }
    .nav-sidebar-v {
      display: block;
    }
    .nav-link {
      display: block;
      width: 100%;
      padding: 0 14px;
      position: absolute;
      z-index: 200;
      bottom: 0;
      left: 0;
      background: #227ccf;
      display: flex;
      justify-content: space-around;
      /deep/ .header-link {
        font-size: 14px !important;
      }
      /deep/ .header-nav-search i {
        font-size: 14px !important;
      }
    }
    .el-divider--vertical {
      margin: 0 8px !important;
    }
    .header-center {
      .header-nav {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        right: -100%;
        z-index: 500;
        transition: all 0.2s ease;
        background: #227ccf;
        overflow: hidden;
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom);
        .header-nav-container {
          height: 100%;
          position: relative;
        }
      }
      .header-up {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 4px 14px;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 400;
        .top-logo-left {
          width: 36%;
          max-width: 210px;
          height: auto;
          margin-right: 0;
          display: block;
        }
        .top-logo {
          width: 100%;
          max-width: 420px;
          display: flex;
          justify-content: flex-start;
          height: auto;
          margin: auto;
          img {
            display: block;
            object-fit: contain;
            width: 68%;
            height: auto;
            margin: 4px 0;
          }
        }
      }
      .header-right {
        display: none;
      }
      .header-logo {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
    }
    .header-menu {
      display: flex;
      align-items: center;
      position: fixed;
      right: 14px;
      top: 8px;
      z-index: 1000;
      i {
        color: #fff;
        margin-right: 10px;
      }
    }

    // ul背景色
    .nav-sidebar-v {
      padding-top: 40px;
      padding-bottom: 40px;
      height: 100%;
      > .el-menu {
        height: 100%;
        overflow-y: auto;
      }
      /deep/ .el-submenu .el-submenu__title {
        font-weight: 500 !important;
        border-bottom: none !important;
      }
      /deep/ .el-submenu a .el-menu-item {
        font-size: 14px;
        font-weight: 500 !important;
        &.is-active {
          color: #fff;
        }
      }
      /deep/ .el-submenu .el-menu-item:focus,
      /deep/ .el-submenu .el-menu-item:hover {
        outline: 0;
        background-color: transparent;
      }
      .el-menu {
        background-color: transparent;
        border-bottom: none;
        border-right: none;
      }
      // li背景色
      /deep/ .el-menu > .el-submenu {
        background-color: #227ccf;
        .el-menu-item,
        .el-submenu__title {
          height: 50px;
          line-height: 50px;
          color: #e8e8e8;
        }
      }
      // li内div
      /deep/ .el-menu > .el-submenu .el-submenu__title {
        color: #e8e8e8;
        background-color: transparent;
        border-bottom: none;
        padding: 0;
        font-size: 14px;
      }
      /deep/ .el-submenu__title i {
        color: #e8e8e8;
        margin-top: -6px;
        font-size: 12px;
      }
    }
  }
}
</style>